import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { changeProductsShowed } from "../../REDUX/actions/revendeur";
import CustomButton from "../Common/CustomButton";
import Loading from "../Common/Loading";
import LoadingButton from "../Common/LoadingButton";
import { useProductsFR } from "../../hooks/product-fr";

const ShowRoomExposedProducts = ({ showRoomItem }) => {
  const dispatch = useDispatch();
  const { productsLoading, products } = useSelector(
    (state) => state.productsReducer,
  );
  const { showRoomsLoading } = useSelector((state) => state.showRoomsReducer);

  const { products: productsFR } = useProductsFR(true);

  const [productsExposed, setproductsExposed] = useState([]);
  const [FRproductsExposed, setFRproductsExposed] = useState([]);

  const allProductsList = [
    ...(products || []),
    ...(productsFR?.length > 0
      ? productsFR.map((product) => ({
          ...product,
          attributes: {
            ...product?.attributes,
            fr: true,
          },
        }))
      : []),
  ];

  useEffect(() => {
    if (showRoomItem) {
      setproductsExposed(
        showRoomItem.attributes.products.data.map((el) => el.id),
      );
      setFRproductsExposed(
        showRoomItem.attributes.fr_products.data.map((el) => el.id),
      );
    }
  }, [showRoomItem]);

  const handleExposedModels = () => {
    dispatch(
      changeProductsShowed(showRoomItem.id, productsExposed, FRproductsExposed),
    );
  };
  return !allProductsList ||
    !productsExposed ||
    !FRproductsExposed ||
    productsLoading ? (
    <Loading />
  ) : (
    <Accordion className={`text-start rounded-10 `}>
      <Accordion.Item
        className="card-body noBorder p-0 rounded-10"
        eventKey="0"
      >
        <Accordion.Header className="rounded-10">
          <h2 className="mb-0 f24 fw-normal">Les modèles exposés</h2>
        </Accordion.Header>
        <Accordion.Body>
          <form className="d-flex flex-wrap justify-content-center">
            {allProductsList.map((el, index) => {
              return (
                <div className="form-check form-switch my-3 w-30" key={index}>
                  <input
                    checked={
                      el?.attributes?.fr
                        ? FRproductsExposed.includes(el.id)
                        : productsExposed.includes(el.id)
                    }
                    className="form-check-input"
                    value={el.id}
                    type="checkbox"
                    id={el.id}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (el?.attributes?.fr) {
                        setFRproductsExposed((prev) =>
                          e.target.checked
                            ? [...prev, value]
                            : prev.filter((id) => id !== value),
                        );
                      } else {
                        setproductsExposed((prev) =>
                          e.target.checked
                            ? [...prev, value]
                            : prev.filter((id) => id !== value),
                        );
                      }
                    }}
                  />
                  <label className="form-check-label" htmlFor={el.id}>
                    {el.attributes.name || el?.attributes?.informations?.name}
                  </label>
                </div>
              );
            })}
          </form>
          <div className="my-3">
            <CustomButton
              disabled={showRoomsLoading}
              buttonText={
                showRoomsLoading ? (
                  <LoadingButton />
                ) : (
                  "Enregistrer les produits exposés"
                )
              }
              callBack={handleExposedModels}
            />
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ShowRoomExposedProducts;
